import { Location } from "vue-router";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { SystemSettings } from "@scrile/api-provider/dist/api/SystemSettingsProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";

export interface StateRoot {
  user: User | null;
  verified: UserVerificationStatus;
  socialLogin: boolean;
  authorities: string[];
  redirectPath: Location | null;
  doNotDisturb: boolean;
  userBalance: number;
  systemSettings: SystemSettings | null;
  creditCardAllowed: boolean;
  currentPaymentSystem: PaymentSystemPublic | null;
  darkMode: boolean;
  nSFWUserSettings: boolean | null;
}
export const state = (): StateRoot => ({
  user: null,
  verified: UserVerificationStatus.UNVERIFIED,
  socialLogin: false,
  authorities: [],
  redirectPath: null,
  doNotDisturb: false,
  userBalance: 0,
  systemSettings: null,
  creditCardAllowed: true,
  currentPaymentSystem: null,
  darkMode: false,
  nSFWUserSettings: null,
});
